import { ApiSpecialization } from '../api-types/specialization.api';
import { Specialization } from '../app-types/specialization.app';

/**
 * Transforms an API specialization object to an app specialization object.
 * @param apiSpecialization The API specialization object to transform.
 * @returns The transformed app specialization object.
 */
export function transformApiSpecializationToAppSpecialization(apiSpecialization: ApiSpecialization): Specialization {
	return {
		id: apiSpecialization.id,
		shortName: apiSpecialization.shortName,
	};
}

/**
 * Transforms an array of API specialization objects to an array of app specialization objects.
 * @param apiSpecializations The array of API specialization objects to transform.
 * @returns The array of transformed app specialization objects.
 */
export function transformApiSpecializationsToAppSpecializations(
	apiSpecializations: ApiSpecialization[],
): Specialization[] {
	return apiSpecializations.map(transformApiSpecializationToAppSpecialization);
}
